import { render, staticRenderFns } from "./SkeletonImg.vue?vue&type=template&id=8911a1fa&"
import script from "./SkeletonImg.vue?vue&type=script&lang=js&"
export * from "./SkeletonImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports